export { default as UsersSelect } from './UsersSelect';
export { default as usersSaga } from './users.saga';
export { default as usersService } from './users.service';
export { default as employeesSaga } from './employees.saga';
export * from './model';

export function isTheOunceEmployee(user) {
  return user && user.management_company_id === 8;
}
